import loadable from '@loadable/component'

export default [
  {
    path: '/WelfareDay',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WelfareDay" */ '~/pages/ToyBricks/CustomComponents/WelfareDay'
        )
    ),
  },
  {
    path: '/WelfareDay/Promotional',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WelfareDay-Promotional" */ '~/pages/ToyBricks/CustomComponents/WelfareDay/pages/Promotional/index'
        )
    ),
  },
]
